module.exports = __webpack_public_path__ + "img/analyze.f2089a1c.svg";